<template>
  <div v-if="1" class="idea-challenges">
    <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
    <transition name="fade">
      <div v-if="contentReady && contentLoadError === ''">
        <!--<ContentHeader :name="award.title.rendered"></ContentHeader>-->
        <ContentHeader name="BU EMPLOYEE of the Year"></ContentHeader>
        <section>
          <div class="card mb-3">
            <div v-if="award._embedded['wp:featuredmedia'] !== undefined" class="featuredImg">
              <img v-if="award._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url"
                :src="award._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url"
                :alt="award._embedded['wp:featuredmedia'][0].alt_text"
                :title="award._embedded['wp:featuredmedia'][0].title.rendered"
              >
            </div>
            <div v-if="award.include_nomination_form[0] === 'Yes'" v-html="award.content.rendered" class="card-body px-3 pb-0"></div>
            <div class="px-3 pb-3">
              <h4 class="mb-3">{{NominationLabel}}</h4>
              <div class="row form-group clearfix">
                <div class="col-md-3 col-lg-3 col-xl-3 mt-3">
                  <label class="h6 text-right" width="100%">
                    GOM
                  </label>
                </div>
                <div class="col-md-8 col-lg-8 col-xl-8">
                  <select v-model="selectedGOMOption" class="form-control mr-2" @change="displaySelectForm">
                    <option class="list-group-item" value="Select GOM">Select GOM</option>
                    <option v-for="gom in GOMList" :key="gom" class="list-group-item" :value="gom">
                      {{ gom }}
                    </option>
                  </select>
                </div>
              </div>
              <div if="WinnerRunnerUpFieldDisplayStatus">
                <div class="row form-group clearfix">
                  <div class="col-md-3 col-lg-3 col-xl-3 mt-3">
                    <label class="h6 text-right" width="100%">
                      Winner/Runner UP
                    </label>
                  </div>
                  <div class="col-md-8 col-lg-8 col-xl-8">
                    <select v-model="selectWinnerRunnerUpStatus" class="form-control mr-2" @change="displaySelectForm">
                      <option value="Winner">Winner</option>
                      <option value="Runner UP">Runner UP</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="award.nomination_event_time_frame.length > 0">
              <ul class="fa-ul" v-if="award.nomination_event_time_frame[0][0][0].nomination_event_date_from !== ''">
                <li class="h6">
                  <span class="fa-li"><i class="fas fa-calendar-alt fa-fw fa-sm text-black-50"></i></span>
                  {{award.nomination_event_time_frame[0][0][0].nomination_event_date_from}} -
                  {{award.nomination_event_time_frame[0][0][0].nomination_event_date_to}}
                </li>
              </ul>
            </div>

            <!-- <ChildNominationEventsList v-if="award.child_nomination_awards.length > 0 && award.child_nomination_awards[0] !== []" class="px-3 pb-3" :awards="award.child_nomination_awards[0][0]" name="The awards categories are:"></ChildNominationEventsList> -->
            <div v-if="madeNomination" class="px-3 pb-3">
              <div class="alert alert-success" role="alert">
                Congratulations, you've nominated:
                <ul>
                  <li v-for="teams in NominationTeamNames" v-bind:key="teams.email">
                    <strong>{{teams.name}}</strong> from {{teams.country}} -
                    Employee number: <strong>{{teams.employeeNum}}</strong><br>
                    Country: <strong>{{teams.country}}</strong><br>
                    GOM: <strong>{{selectedGOMOption}}</strong><br>
                  </li>
                </ul>
              </div>
              <button type="button" name="button" class="btn btn-primary" v-on:click="removeNominee()">Nominate someone else</button>
            </div>
            <div v-if="award.include_nomination_form[0] === 'Yes' && award.nomination_fields.length > 0 && !madeNomination && displayForm" class="px-3 pb-3">
              <form v-on:submit.prevent=""><!-- Added OnSubmit; after few plugins update issues -->
                <div class="input-group input-group-lg mb-4">
                  <vue-bootstrap-typeahead class="form-control" v-model="nominatedPerson" :data="nomineesList" @keydown.enter="search" :serializer="item => item.email" placeholder="Search by email address" prepend="" ></vue-bootstrap-typeahead>
                  <div class="input-group-append">
                    <button class="btn btn-primary" type="submit" :disabled="nominatedPerson.length === 0" v-on:click="checkNominationCount()">{{NominationButtonText}}</button>
                  </div>
                </div>
              </form>
              <PreContentHeader :show-loading="searchingForEmployee" :error-message="searchingForEmployeeError"></PreContentHeader>
              <div class="p-3 mb-2 bg-primary text-white border border-primary font-weight-bold mt-1" v-if="NominationTeamNames.length === 1">Continue to add names if you would like to complete a team nomination for Teams nomination</div>
              <transition name="grow">
                <div v-if="showNominationForm || NominationTeamNames.length > 0">
                  <hr>
                  <strong>You are nominating:</strong><br>
                  <div v-if="isTeamAwards">
                    <ul>
                      <li v-for="teams in NominationTeamNames" v-bind:key="teams.email">
                        <strong>{{teams.name}}</strong> from {{teams.country}} -
                        Employee number: <strong>{{teams.employeeNum}}</strong><br>
                        Country: <strong>{{teams.country}}</strong><br>
                        GOM: <strong>{{selectedGOMOption}}</strong><br>
                        <button type="button" class="btn btn-link p-0" v-on:click="removeTeamNominee(teams)">X Remove</button>
                      </li>
                    </ul>
                  </div>
                  <hr>
                  <form v-on:submit.prevent=""><!-- Added OnSubmit; after few plugins update issues -->
                    <div v-for="formField in nominationFields" v-bind:key="formField.index">
                      <NominationField
                        :type="formField.type"
                        :description="formField.description"
                        :secondary-description="formField.secondaryDescription"
                        :description-lvl-two="formField.description_lvl_two"
                        :secondary-description-lvl-two="formField.secondary_description_lvl_two"
                        :is-required="formField.isRequired"
                        :checkbox-labels="formField.checkboxLabels"
                        v-on:updatedFieldContent="fieldUpdated($event)"
                        :validationMethod="formField.validationMethod"
                        :displayField="formField.display_field"
                        :options="formField.options"
                        :error-class="formField.errorClass"
                        :labelContent="selectedBUOption">
                      </NominationField>
                    </div>
                    <div class="row py-1">
                      <div class="col offset-md-4 offset-lg-4 offset-xl-3">
                        <div class="form-group form-check">
                          <input type="checkbox" class="form-check-input" id="terms" v-model="termsCheckbox" required>
                          <label for="terms" class="form-check-label">Nomination Complete. I accept the 
                            <router-link to="/page/multichoice-recognition-terms-and-conditions" target="_blank">Terms &amp; Conditions</router-link>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="row pt-2 mb-4">
                      <div class="col offset-md-4 offset-lg-4 offset-xl-3" v-if="submitClicked">
                        <button @click="submitNomination" type="submit" class="btn btn-primary btn-lg">Submit Nomination</button>
                      </div>
                    </div>
                  </form>
                </div>
              </transition>
              <PreContentHeader :show-loading="creatingNomination" :error-message="createNominationError"></PreContentHeader>
            </div>
            <div v-if="award.include_nomination_form[0] === 'No'">
              <div class="p-4">
                <h4>Form Currently Unavailable</h4>
                <hr>
                <p>We're sorry, but the form you are trying to access is currently unavailable. If you have any questions or concerns, please don't hesitate to contact our HR team for assistance.</p>
              </div>
            </div>
          </div>
        </section>
        <div v-if="award.additional_content.length > 0 && award.additional_content[0] !== '' && award.additional_content !== ''" class="card mb-3">
          <div class="card-body" v-html="award.additional_content[0]"></div>
        </div>
      </div>
    </transition>
  </div>
  <div v-else>
    <!--h5> You do not have permission to access this page. Please contact HR team to provide role.</h5-->
  </div>
</template>

<script>
import ContentHeader from '@/components/ContentHeader'
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import WordpressRestURI from '@/helpers/WordpressRestURI.js'
import ADauthentication from '@/helpers/ADauthentication.js'
import NominationNotification from '@/helpers/NominationNotification.js'
import ChildNominationEventsList from '@/components/ChildNominationEventsList'
import NominationField from '@/components/NominationField'
import Loading from '@/components/Loading'
import PreContentHeader from '@/components/PreContentHeader'
import vueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      award: [],
      errors: [],
      contentReady: false,
      contentLoadError: '',
      nominationContent: [],
      nominationFields: [],
      userDetails: [],
      BUOptions: [],
      nominatedPerson: '',
      madeNomination: false,
      displayForm: false,
      selectedBUOption: 'Select BU',
      WinnerRunnerUpFieldDisplayStatus: false,
      selectWinnerRunnerUpStatus: 'Winner',
      GOMLabel: '',
      selectedGOMOption: 'Select GOM',
      termsCheckbox: false,
      validatedNominee: '',
      showNominationForm: false,
      creatingNomination: false,
      createNominationError: '',
      searchingForEmployee: false,
      searchingForEmployeeError: '',
      isContractorErrorSet: true,
      isTeamAwards: false,
      submitClicked: true,
      NominationButtonText: 'Nominate',
      NominationLabel: 'Nominate an Employee for this Award',
      NominationPlaceholder: 'Search by name and surname or email address...',
      NominationTeamNames: [],
      NominationTeamsContent: [],
      nomineesList: [],
      employeeHierarchy: {},
      options: [],
      selectedOption: '',
      supportingDocList: [],
      supportingDocLength: 0,
      BUList: [],
      GOMList: [],
      TotalBUList: [],
      mahCountryList:["ghana","nigeria","botswana","namibia","tanzania","kenya","uganda","zambia","angola","mozambique","ethiopia"],
      mediaUploadCallDone: false,
      sendEmaiCallDone: false
    }
  },
  components: {
    PreContentHeader,
    ContentHeader,
    ChildNominationEventsList,
    NominationField,
    Loading,
    vueBootstrapTypeahead
  },
  computed: {
    ...mapGetters([
      'viewEmployeeAwards'
    ])
  },
  methods: {
    checIfBothCallCompleted() {
      console.log(' checIfBothCallCompleted ', this.mediaUploadCallDone, this.sendEmaiCallDone)
      if (this.mediaUploadCallDone && this.sendEmaiCallDone) {
        console.log('both calls are done')
      }
    },
    displaySelectForm: function() {
      this.removeNominee()
      console.log('displayBUOptions selectedGOMOption  ', this.selectedGOMOption, this.nominationFields, this.nominationFields.length)
      for(let index = 0; index < this.GOMList.length; index++) {
        console.log(' displayBUOptions ',this.selectedGOMOption, index , this.GOMList[index])
        if (this.GOMList[index].includes(this.selectedGOMOption)) {
          this.GOMLabel = this.GOMList[index]
          this.BUOptions = this.BUList[index]
          console.log('displayBUOptions UpdatedGOM 256', this.BUList[index], this.GOMLabel)
          break
        }
      }
      if (this.selectedGOMOption == 'Select GOM') {
        this.GOMLabel = 'Select GOM'
        this.BUOptions = []
        this.displayForm = false
        this.selectWinnerRunnerUpStatus = 'Winner'
        this.WinnerRunnerUpFieldDisplayStatus = false
      } else {
        this.displayForm = true
      }
    },
    updatedNominationField: function() {
      for (var j = 0; j < this.nominationFields.length; j++) {
        if (this.nominationFields[j].description === 'BU') {
          this.nominationFields[j].options = this.selectedBUOption
          console.log('updatedNominationField this.nominationFields[j] ', this.nominationFields[j])
        }
        if (this.nominationFields[j].description === 'Winner/Runner UP') {
          this.nominationFields[j].options = this.selectWinnerRunnerUpStatus
          console.log('updatedNominationField this.nominationFields[j] ', this.nominationFields[j])
        }
      }
    },
    setValidatedNominee: function (userData) {
      console.log(' setValidatedNominee ', userData)
      if (this.checkForDuplicateNominee(userData)) {
        this.validatedNominee = {
          name: userData.firstname + ' ' + userData.lastname,
          slug: userData.email.replace(/\./g, '-').replace(/@/g, '').toLowerCase(),
          department: userData.department,
          company: (userData.company === '') ? 'Multichoice' : userData.company,
          employeeNum: userData.employeenumber,
          country: userData.country,
          email: userData.UPN,
          lineManagerName: (!userData.managername) ? userData.employeehierarchy['line-manager-name'][0] : userData.managername,
          lineManagerEmail: (!userData.manageremail) ? userData.employeehierarchy['line-manager-email'][0] : userData.manageremail,
          employeeHierarchy: userData.employeehierarchy
        }
        this.NominationTeamNames.push(this.validatedNominee)
        this.getPageLabel()
      }
    },
    // code to get Label of page
    getPageLabel: function() {
      this.NominationLabel = "BU Employee Of The Year Nomination"
    },
    searchLocalDB: function () {
      this.searchingForEmployeeError = ''
      WordpressRestAPI.getLocalDbUserLookup(this.nominatedPerson.toLowerCase())
        .then(response => {
        if (this.checkForDuplicateNominee(response.data))
          this.setValidatedNominee(response.data)
          if (this.$store.getters.getUserEmail.toLowerCase() === response.data.email.toLowerCase()) {
            this.showNominationForm = false
            this.searchingForEmployee = false
            alert('You can\'t nominate yourself. Please nominate one of your colleagues instead.')
            this.searchingForEmployeeError = 'You can\'t nominate yourself. Please nominate one of your colleagues instead.'
          } else {
            this.showNominationForm = true
            this.searchingForEmployee = false
          }
        })
        .catch(e => {
          if (this.isContractorErrorSet) {
            this.searchingForEmployee = false
            this.searchingForEmployeeError = 'We could not find a user with the names: ' + this.nominatedPerson + '. Make sure you entered the correct name and surname or try searching by email'
          }
          this.isContractorErrorSet = true
          console.error(e)
        })
    },
    searchByEmail: function () {
      console.log('searchByEmail 305')
      this.searchingForEmployeeError = ''
      ADauthentication.getUserInfoByEmail(this.nominatedPerson,'EY',this.selectedBUOption)
        .then(response => {
          console.log('searchByEmail getUserInfoByEmail 309 ', response.data, response.data.employeeHierarchy)
          if (response.data) {
            this.setValidatedNominee(response.data)
            this.searchingForEmployee = false
          }
        })
        .catch(e => {
          if (this.isContractorErrorSet) {
            this.searchingForEmployee = false
            this.searchingForEmployeeError = 'We could not find a user with the email: ' + this.nominatedPerson + '. Make sure you entered the correct email address or try searching by name and surname'
          }
          this.isContractorErrorSet = true
          console.error(e)
        })
    },
    searchByUsername: function () {
      this.searchingForEmployeeError = ''
      ADauthentication.getUserInfoByUsername(this.nominatedPerson.replace(' ', '.').toLowerCase())
        .then(response => {
          console.log(' 262 ', response.data)
          if (!response.data) {
            this.searchingForEmployee = false
            this.searchingForEmployeeError = 'We could not find a user with the names: ' + this.nominatedPerson + '. Make sure you entered the correct name and surname or try searching by email'
          } else {
            this.setValidatedNominee(response.data)
            if (this.$store.getters.getUserEmail.toLowerCase() === response.data.email.toLowerCase()) {
              this.showNominationForm = false
              this.searchingForEmployee = false
              alert('You can\'t nominate yourself. Please nominate one of your colleagues instead.')
              this.searchingForEmployeeError = 'You can\'t nominate yourself. Please nominate one of your colleagues instead.'
            } else {
              this.showNominationForm = true
              this.searchingForEmployee = false
            }
          }
        })
        .catch(e => {
          if (this.isContractorErrorSet) {
            this.searchingForEmployee = false
            this.searchingForEmployeeError = 'We could not find a user with the names: ' + this.nominatedPerson + '. Make sure you entered the correct name and surname or try searching by email'
          }
          this.isContractorErrorSet = true
          console.error(e)
        })
    },
    checkForDuplicateNominee: function(data) {
      var self = this
      if (!data.email) {
        data.email = data.UPN
      }

      if (data.email) {
        var dupliEmail = []
        if (self.NominationTeamNames.length > 0) {
            dupliEmail = self.NominationTeamNames.filter(d => data.email && d.email.toLowerCase() ===  data.email.toLowerCase() || d.name.toLowerCase() === data.firstname.toLowerCase() + ' ' + data.lastname.toLowerCase())
        }
        if (data.email && self.$store.getters.getUserEmail.toLowerCase() === data.email.toLowerCase() || self.$store.getters.getUserName.toLowerCase() === data.firstname.toLowerCase() + ' ' + data.lastname.toLowerCase()) {
            dupliEmail.push(data.email)
            self.searchingForEmployeeError = 'You can\'t nominate yourself. Please nominate one of your colleagues instead.'
            return false
        }
        if (dupliEmail.length > 0) {
            self.searchingForEmployeeError = 'Duplicate Nominee ' + data.email
            return false
        }
        if (data.employeehierarchy) {
          if (data.employeehierarchy.ishod[0] ===  'Yes') {
              self.searchingForEmployeeError = 'SELECTED NOMINEE '  + data.email + ' IS HOD (OR ABOVE) AND CANNOT BE NOMINATED'
              this.searchingForEmployee = false
              return false
          }
        }
        if (data.employeehierarchy === false) {
            self.searchingForEmployeeError = 'Nominee ' + data.email + ' is not present in Think Tank list. For further assistance, Please contact thinktank@multichoice.co.za'
            this.searchingForEmployee = false
            return false
        }
        console.log('checkForDuplicateNominee 388 response.data.businessunit ', data.businessunit,' this.selectedBUOption ', this.selectedBUOption)
        return true
      } else {
        self.searchingForEmployeeError = 'Nominee ' + self.nominatedPerson + ' is not present in Think Tank list. For further assistance, Please contact thinktank@multichoice.co.za'
          return false
      }
    },
    getHCBPBUDetails: async function () {
      try {
        const response = await WordpressRestAPI.getCustomViewContent('thinktank_authentication/v1/getUserDetailEOY?email=' + this.userDetails.email)
        console.log('review list-> ', this.userDetails.email, response.data, response.data.BU, this.award.nomination_fields[0][0])
        if (response.data && response.data.BU) {
          this.award.nomination_fields[0][0][1].options = response.data.BU
          this.BUOptions = response.data.BU
          this.GOMLabel = response.data.GOM
          this.BUList = response.data.BUList
          this.GOMList = response.data.GOMList
        }
      } catch (e) {
        this.contentLoadError = 'Oops! We had a problem loading nominations. Please try again later.';
        console.error(e);
        this.contentReady = true;
      }
    },
    // code to add user to Nomination list
    setNominee: function () {
      console.log(' 431 setNominee called', this.NominationTeamNames.length)
      var self = this
      if (self.NominationTeamNames.length < 1) {
        self.searchingForEmployee = true
        self.searchingForEmployeeError = ''
        if (self.nominatedPerson.toLowerCase().indexOf('irdeto') > -1 || self.nominatedPerson.toLowerCase().indexOf('showmax') > -1) {
          if ((self.$route.params.name === 'employee-of-the-year-2018' || self.$route.params.name === 'team-awards-2018') && this.nominatedPerson.toLowerCase().indexOf('showmax') === -1) {
            alert('Irdeto can\'t be nominated for this Awards. Please nominate your colleagues for Innovation Awards.')
            self.searchingForEmployee = false
          } else if (self.$store.getters.getUserEmail.toLowerCase() !== self.nominatedPerson.toLowerCase()) {
            self.searchLocalDB()
          } else {
            alert('You can\'t nominate yourself. Please nominate one of your colleagues instead.')
            self.searchingForEmployee = false
          }
        } else if (self.nominatedPerson.indexOf('@') > -1) {
          if (self.$store.getters.getUserEmail.toLowerCase() !== self.nominatedPerson.toLowerCase()) {
            self.searchByEmail()
          } else {
            alert('You can\'t nominate yourself. Please nominate one of your colleagues instead.')
            self.searchingForEmployee = false
          }
        } else {
          if (self.$store.getters.getUserName.toLowerCase() !== self.nominatedPerson.toLowerCase()) {
            console.log(' 346 ')              
            self.searchByUsername()
          } else {
            alert('You can\'t nominate yourself. Please nominate one of your colleagues instead.')
            self.searchingForEmployee = false
          }
        }
      } else{
        alert('You can only add only 1 person for nomination')
      }
    },
    // Below code is to remove all members. This function is used for Nominate someone else
    removeNominee: function () {
      this.validatedNominee = {name: '', department: '', employeeNum: ''}
      this.showNominationForm = false
      this.madeNomination = false
      this.NominationTeamNames = []
      this.submitClicked = true
      this.nominationContent = []
      this.termsCheckbox = false
      this.createNominationError = ''
      this.searchingForEmployeeError = ''
      this.setNominationContent(this.award.nomination_fields[0][0])
    },
    // Remove single user
    removeTeamNominee: function (index) {
      this.NominationTeamNames.splice(this.NominationTeamNames.indexOf(index), 1)
      if (this.NominationTeamNames.length === 0) {
        this.showNominationForm = false
      }
      this.getPageLabel()
      var slugArray = this.NominationTeamNames.map(function(member) {
          return member.slug;
      });
      // Convert the 'emailArray' to a string with a comma as the separator
      var slugString = slugArray.join(',')
      if (slugString) {
        this.submitClicked = true
      }
    },
    setPostContent: function (type) {
      var content = ''
      var plainContent = ''
      for (var i = 0; i < this.nominationContent.length; i++) {
        if (this.nominationContent[i].displayField)
          console.log('setPostContent this.nominationContent ', this.nominationContent)
          console.log('setPostContent this.nominationContent[i].label ', i, this.nominationContent[i].label)
          if (this.nominationContent[i].label === 'Detailed Motivation') {
            content += '<strong>' + this.nominationContent[i].label + '</strong><br><p>' + this.nominationContent[i].content + '</p>'
            plainContent += '<h>' + this.nominationContent[i].label + '<h> @#$% <c>' + this.nominationContent[i].content + '<c> @#$% '
          }
      }
      return (type === 'nohtml' ? plainContent : content)
    },
    ValidateFields: function (value, type, label) {
      if (type.toLowerCase() === 'email') {
        if (value.indexOf('@') === -1 || value.indexOf('.') === -1) {
          alert('Invalid ' + label + ' !')
          return false
        } else if (value.split('@').length > 2) {
          alert ('Only one mail allowed for ' + label + ' !' )
          return false
        }
        return true
      }
    },
    // code to check Nomination Field and Nomination Content for validation
    readyToSubmitNomination: function () {
      var contentPassedValidation = true
      this.searchingForEmployeeError = ''
      for (var j = 0; j < this.nominationContent.length; j++) {
        this.nominationFields[j].errorClass = ''
        console.log(' readyToSubmitNomination 535 ', this.nominationFields[j].label)
        if (this.nominationFields[j].display_field === false || this.nominationFields[j].label === 'GOM' || this.nominationFields[j].label === 'BU') {
          continue
        } else {
          if (this.nominationFields[j].validationMethod) {
            contentPassedValidation = this.ValidateFields(this.nominationContent[j].content, this.nominationFields[j].validationMethod, this.nominationContent[j].label)
            console.log(' readyToSubmitNomination  508 ', contentPassedValidation)
          }
          console.log('readyToSubmitNomination 509 contentPassedValidation j ', j,  contentPassedValidation, this.nominationContent[j])
          if (this.nominationContent[j].required === 'false' && this.nominationContent[j].content === '' && !this.nominationContent[j].validated) {
            this.nominationContent[j].validated = true
            console.log('readyToSubmitNomination 513 contentPassedValidation j ', j,  contentPassedValidation)
          }
          if (this.nominationContent[j].validated === false) {
            contentPassedValidation = false
            this.nominationFields[j].errorClass = 'field-not-validated'
            console.log('readyToSubmitNomination 516 contentPassedValidation', contentPassedValidation, this.nominationContent[j])
          }
          var supportingDoc = this.nominationContent.filter(x => {
            return (x.label.indexOf('Supporting Evidence') > -1 || x.label.indexOf('Employee Image') > -1) && x.content !== '';
          });
          console.log('readyToSubmitNomination nominationContent ', this.nominationContent)
          console.log('readyToSubmitNomination supportingDoc ', supportingDoc)
          if (supportingDoc.length < 1) {
            //return false
          }
          if (!supportingDoc[0] || supportingDoc[0].content === undefined || supportingDoc[0].content === null) {
              console.log('readyToSubmitNomination inside else 451');
              //return false;
          }
          if (!supportingDoc[1] || supportingDoc[1].content === undefined || supportingDoc[1].content === null || supportingDoc[1].content.length < 1) {
              console.log('readyToSubmitNomination inside else 457');
              //return false;
          }
          // Stop immedieatly any field validation is false
          if (contentPassedValidation === false)
            break;
        }
      }
      console.log('readyToSubmitNomination this.termsCheckbox ', this.termsCheckbox, contentPassedValidation, 'result ', this.termsCheckbox && contentPassedValidation)
      return this.termsCheckbox && contentPassedValidation
    },
    addMediaToNominationPost: function (mediaID, postID) {
      var self = this
      var sendNomination = {
        method: 'POST',
        data: {
          supporting_documentation: mediaID
        },
        headers: {
          'Authorization': localStorage.getItem('userToken'),
          'Content-Type': 'application/json'
        },
        json: true
      }
      WordpressRestAPI.endpointWithAuthetication(sendNomination, 'nomination/' + postID)
        .then(function (response) {

          WordpressRestAPI.getCustomViewContent('Nomination/v1/attachDocument?PostID=' + postID + '&mediaID=' + mediaID)
          .then(response => {
            console.log('data includes', response.data)
            self.madeNomination = true
            self.creatingNomination = false
            self.mediaUploadCallDone = true
            console.log(' mediaUploadCallDone done ', self.mediaUploadCallDone)
          })
          .catch(e => {
            console.error(e)
          })

          self.supportingDocLength = 0
          self.supportingDocList = []
        })
        .catch(function (e) {
          console.error(e)
        })
    },
    uploadSupportingDocumentation: function (postID, supportingDoc) {
      var self = this
      var formData = new FormData()
      formData.append('file', supportingDoc)
      if (self.NominationTeamNames.length === 1) {
        formData.append('title', postID + ' Supporting Media of Employee of the Year for ' + self.validatedNominee.name)
        formData.append('caption', postID + ' Supporting Media of Employee of the Year for ' + self.validatedNominee.name)
      }

      var uploadMedia = {
        method: 'POST',
        processData: false,
        contentType: false,
        data: formData,
        headers: {
          'Authorization': localStorage.getItem('userToken'),
          'Content-Type': 'application/json'
        },
        json: true
      }
      console.log('uploadSupportingDocumentation formData ', formData , uploadMedia)
      WordpressRestAPI.endpointWithAuthetication(uploadMedia, 'media')
      .then(function (response) {
        self.supportingDocList.push(response.data.id)
        console.log('uploadSupportingDocumentation self.supportingDocLength ', self.supportingDocLength, ' self.supportingDocList.length ', self.supportingDocList.length)
        if (self.supportingDocLength === self.supportingDocList.length) {
          self.addMediaToNominationPost(self.supportingDocList, postID)
        }
      })
      .catch(function (e) {
        console.error(e)
      })
    },
    checkForMediaUpload: function (postID) {
      var supportingDoc = this.nominationContent.filter(x => {
        return (x.label.indexOf('Supporting Evidence') > -1) && x.content !== '';
      });

      var employeeImageDocs = this.nominationContent.filter(x => {
        return (x.label.indexOf('Employee Image') > -1) && x.content !== '';
      });

      if (supportingDoc.length > 0 && supportingDoc[0].content) {
        this.supportingDocLength = 1
      }

      if (employeeImageDocs && employeeImageDocs.length > 0 && employeeImageDocs[0] && employeeImageDocs[0].content) {
        if (employeeImageDocs[0] && employeeImageDocs[0].content) {
          const filesArray = Array.from(employeeImageDocs[0].content)
          // Traverse the array using forEach
          filesArray.forEach(file => {
            this.supportingDocLength++
          });
        }
      }

      console.log('checkForMediaUpload nominationContent ', this.nominationContent,  this.supportingDocLength)
      console.log('checkForMediaUpload supportingDoc ', employeeImageDocs, employeeImageDocs.length)

      if (supportingDoc.length > 0 && supportingDoc[0].content) {
        this.uploadSupportingDocumentation(postID, supportingDoc[0].content,'document')
      } else {
        console.log(' checkForMediaUpload else supporting documentation not called ')
      }


      if (employeeImageDocs && employeeImageDocs.length > 0 && employeeImageDocs[0] && employeeImageDocs[0].content) {
        console.log('668')
        if (employeeImageDocs[0] && employeeImageDocs[0].content) {
          const filesArray = Array.from(employeeImageDocs[0].content)
          console.log('checkForMediaUpload supportingDoc filesArray 673', filesArray, filesArray.length)
          // Traverse the array using forEach
          filesArray.forEach(file => {
            console.log('checkForMediaUpload supportingDoc file 689', file)
            this.uploadSupportingDocumentation(postID, file,'image')
          });
        } else {
          this.imageDone = true
          console.log('681')
        }
      }

      if (this.supportingDocLength === 0) {
        this.imageDone = true
        this.madeNomination = true
        this.creatingNomination = false
        this.mediaUploadCallDone = true
        console.log('687 mediaUploadCallDone done ', this.mediaUploadCallDone)
      }
      console.log('checkForMediaUpload end of  checkForMediaUpload')
    },
    checkForMediaUpload_single: function (postID) {
      var supportingDoc = this.nominationContent.filter(x => {
        return (x.label.indexOf('Supporting Evidence') > -1 || x.label.indexOf('Employee Image') > -1) && x.content !== '';
      });
      console.log('checkForMediaUpload nominationContent ', this.nominationContent)
      console.log('checkForMediaUpload supportingDoc ', supportingDoc, supportingDoc.length)

      if (supportingDoc.length > 0) {
        this.supportingDocLength = supportingDoc.length
        console.log('checkForMediaUpload inside uploadSupportingDocumentation 0', supportingDoc[0].content)
        this.uploadSupportingDocumentation(postID, supportingDoc[0].content)
        console.log('checkForMediaUpload supportingDoc filesArray 631', supportingDoc[0].content.length, this.supportingDocLength)

        if (supportingDoc[1] && supportingDoc[1].content) {
          const filesArray = Array.from(supportingDoc[1].content)
          console.log('checkForMediaUpload supportingDoc filesArray 631', filesArray, filesArray.length)
          // Traverse the array using forEach
          this.supportingDocLength = this.supportingDocLength + (filesArray.length - 1)
          filesArray.forEach(file => {
            console.log('checkForMediaUpload supportingDoc file 633', file)
            this.uploadSupportingDocumentation(postID, file)
          });
        }
      } else {
        this.madeNomination = true
        this.creatingNomination = false
        this.mediaUploadCallDone = true
        console.log(' mediaUploadCallDone done ', this.mediaUploadCallDone)
      }
      console.log('checkForMediaUpload end of  checkForMediaUpload')
    },
    assignUserCommunities: function () {
      const userCommunityIDstring = this.$store.getters.getUserCommunityIDstring;
      if (userCommunityIDstring) {
        return this.award.community_categories.filter(
          f => userCommunityIDstring.split(',').map(x => parseInt(x)).includes(f)
        );
      } else {
        return [] // Return an empty array if userCommunityIDstring is undefined or empty
      }
    },
    getNominationEventCategory: function () {
      var nominationEventCategory = []
      nominationEventCategory.push('20')
      nominationEventCategory.push('139')
      return nominationEventCategory
    },
    getNominationTitle: function () {
      var self = this
      var nominationTitle = self.validatedNominee.name + ', Employee of the Year'
      return nominationTitle
    },
    // Below code is for submitting Nomination form
    createNominationEntry: function () {
      console.log('createNominationEntry sendNomination ')
      this.showNominationForm = false
      this.creatingNomination = true
      this.submitClicked = false
      var self = this
      console.log('createNominationEntry award.nomination_fields ', self.award.nomination_fields)
      console.log('createNominationEntry self.nominationFields ', self.nominationFields)
      if (self.$store.state.UserProfile.currentUser.meta.communities !== undefined && self.$store.state.UserProfile.currentUser.meta.communities.length > 0) {
        var employeeCompany = self.$store.state.UserProfile.currentUser.meta.communities
      } else {
        var employeeCompany = self.validatedNominee.department
      }
      if (self.$store.state.UserProfile.currentUser.meta.employeeNumber !== undefined && self.$store.state.UserProfile.currentUser.meta.employeeNumber.length > 0) {
        var employeeNumber = self.$store.state.UserProfile.currentUser.meta.employeeNumber
      } else {
        var employeeNumber = self.validatedNominee.employeeNum
      }
      const team = self.NominationTeamNames && self.NominationTeamNames[0]
      const businessUnit = team && team.employeeHierarchy && team.employeeHierarchy.businessunit && team.employeeHierarchy.businessunit[0]
      if (businessUnit) {
        self.selectedBUOption = businessUnit
      }
      var sendNomination = {
        method: 'POST',
        data: {
          title: self.getNominationTitle(),
          nomination_event_category: self.getNominationEventCategory(),
          community_categories: self.assignUserCommunities(),
          nomination_approve_decline: 'Accepted',
          nominee_name: self.validatedNominee.name,
          nominee_slug: self.validatedNominee.slug,
          nominee_company: self.validatedNominee.company,
          status: 'publish',
          content: self.setPostContent('html'),
          nominationdata: self.setPostContent('nohtml'),
          winnerRunnerStatus: self.selectWinnerRunnerUpStatus,
          BUEOYGOM: self.GOMLabel,
          BUEOYBUField: self.selectedBUOption,
          nominator_details: [{
            'employee-number': employeeNumber,
            'employee-company': employeeCompany
          }]
        },
        headers: {
          'Authorization': localStorage.getItem('userToken'),
          'Content-Type': 'application/json'
        },
        json: true
      }

      sendNomination.data.teamnominationworkflow = []
      var d = new Date()
      let nominationDate = d.getFullYear() + '-' + parseInt(parseInt(d.getMonth()) + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds()

      // Push Line Manager
      if (self.NominationTeamNames[0].employeeHierarchy['line-manager-email'][0]) {
        sendNomination.data.teamnominationworkflow.push({'project_sponsor_name': 'Manager', 'project_sponsor_email': self.NominationTeamNames[0].employeeHierarchy['line-manager-email'][0], 'project_sponsor_comment': '', 'project_sponsor_status': 'Approve', 'project_sponsor_datetime' : nominationDate})
      }

      // Push Exco2 Manager
      if (self.NominationTeamNames[0].employeeHierarchy['exco2-email'][0]) {
        sendNomination.data.teamnominationworkflow.push({'project_sponsor_name': 'Exco2', 'project_sponsor_email': self.NominationTeamNames[0].employeeHierarchy['exco2-email'][0], 'project_sponsor_comment': '', 'project_sponsor_status': 'Approve', 'project_sponsor_datetime' : nominationDate})
      }

      // Push HRBP
      if (self.NominationTeamNames[0].employeeHierarchy['hrbp-email'][0]) {
        sendNomination.data.teamnominationworkflow.push({'project_sponsor_name': 'HRBP', 'project_sponsor_email': self.NominationTeamNames[0].employeeHierarchy['hrbp-email'][0], 'project_sponsor_comment': '', 'project_sponsor_status' : 'Approve', 'project_sponsor_datetime': nominationDate})
      }
      if (self.NominationTeamNames.length > 1) {
        sendNomination.data.isteamaward = 'true'
      }
      if (self.NominationTeamNames.length > 1) {
        sendNomination.data.nominationteam = []
        sendNomination.data.nominee_name = ''
        sendNomination.data.nominee_slug = ''
        for (var i = 0; i < self.NominationTeamNames.length; i++) {
          sendNomination.data.nominationteam.push({
            'member_name': self.NominationTeamNames[i].name,
            'member_approve_reject': 'Accepted',
            'member_company': self.NominationTeamNames[i].company,
            'member_employee_number': self.NominationTeamNames[i].employeeNum,
            'member_slug': self.NominationTeamNames[i].slug,
            'email': self.NominationTeamNames[i].email
          })
        }
      }
      console.log(' sendNomination ', sendNomination)
      WordpressRestAPI.endpointWithAuthetication(sendNomination, 'nomination')
      .then(function (response) {
        console.log('  response ', response.data)
        self.checkForMediaUpload(response.data.id)
        self.sendEmailNotificationToNominator(response.data)
      })
      .catch(function (e) {
        self.createNominationError = 'Oops! We had a problem adding your nomination. Please try again later.'
        console.error(e)
      })
    },
    sendEmailNotificationToNominator: function (nomination) {
      var self = this
      var d = new Date()
      let winnerRunnerStatus = nomination.winnerRunnerStatus[0]
      let nominationDate = d.getFullYear() + '-' + parseInt(parseInt(d.getMonth()) + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds()
      let ccMail = 'Ruksanah.Ally@multichoice.co.za,shankar.mahire@nihilent.com,halecia.naicker@mnet.co.za,ThinkTank@multichoice.co.za'
      if (this.selectWinnerRunnerUpStatus === 'Winner') {
        //ccMail = ccMail + ',Tshepiso.Malatjie@supersport.com'
      }
      let reviewLink = WordpressRestURI.frontEndDomain + 'login/my-profile+review-nomination-bu-employee-award+' + nomination.id
      let emailBody = NominationNotification.confirmationOfBUEOYNominationBody({
        nominee: this.validatedNominee.name,
        nominator: this.$store.getters.getUserName,
        nominationDate: nominationDate,
        reviewLink: reviewLink,
        winnerRunnerStatus: winnerRunnerStatus
      })

      var emailNominationNotification = {
        method: 'POST',
        data: {
          to: this.$store.getters.getUserEmail,
          cc: ccMail,
          subject: 'NOTIFICATION: #WeSeeYou Recognition Award Confirmation',
          message: emailBody
        },
        json: true
      }

      WordpressRestAPI.sendEmail(emailNominationNotification)
      .then(function (response) {
        console.log(response.data)
        self.sendEmaiCallDone = true
        console.log(' sendEmaiCallDone done ', self.sendEmaiCallDone)
      })
      .catch(function (e) {
        console.error(e)
      })
    },
    submitNomination: function () {
      //this.submitClicked = false
      if (this.readyToSubmitNomination()) {
        this.createNominationEntry()
      } else {
        this.submitClicked = true
      }
    },
    fieldUpdated: function (fieldDetails) {
      for (var i = 0; i <= this.nominationContent.length; i++) {
        console.log('fieldUpdated end nominationContent 778 nominationContent ', this.nominationContent[i].label, ' fieldDetails ', fieldDetails.label, fieldDetails.content)
        if (this.nominationContent[i].label === 'GOM') {
          this.nominationContent[i].validated = true
        }
        if (this.nominationContent[i].label === 'BU') {
          this.nominationContent[i].validated = true
        }
        if (this.nominationContent[i].label === 'Winner/Runner UP') {
          this.nominationContent[i].validated = true
        }
        if (this.nominationContent[i].label === fieldDetails.label) {
          this.nominationContent[i].content = fieldDetails.content
          this.nominationContent[i].validated = fieldDetails.validated
          this.nominationContent[i].displayField = fieldDetails.displayField
          break
        }
      }
      console.log('fieldUpdated end nominationContent ', this.nominationContent)
    },
    setNominationContent: function (nominationFields) {
      var self = this
      self.nominationFields = nominationFields.map(function (x, index) {
        var displayFieldVal = x.display_field === "No" ? false : true
        var BUOptions = []
        var GOMLabel = []
        var WinnerRunnerUpLabel = []
        if (self.BUOptions ) {
          BUOptions = self.selectedBUOption
        }
        if (self.GOMLabel ) {
          GOMLabel = self.GOMLabel
        }
        if (self.selectWinnerRunnerUpStatus ) {
          WinnerRunnerUpLabel = self.selectWinnerRunnerUpStatus
        }
        if (x.field_description === 'BU') {
          //console.log('setNominationContent  x 731', x, displayFieldVal)
          return {
            type: x.form_field_type,
            description: x.field_description,
            secondaryDescription: x.field_secondary_description,
            isRequired: x.required_nomination_field,
            checkboxLabels: x.checkbox_labels,
            errorClass: '',
            index: index + x.form_field_type,
            description_lvl_two: x.description_lvl_two,
            secondary_description_lvl_two: x.secondary_description_lvl_two,
            display_field: displayFieldVal,
            validationMethod: x.validationmethod,
            options: BUOptions
          }
        } else if (x.field_description === 'GOM') {
          //console.log('setNominationContent  x 747', x, displayFieldVal)
          return {
            type: x.form_field_type,
            description: x.field_description,
            secondaryDescription: x.field_secondary_description,
            isRequired: x.required_nomination_field,
            checkboxLabels: x.checkbox_labels,
            errorClass: '',
            index: index + x.form_field_type,
            description_lvl_two: x.description_lvl_two,
            secondary_description_lvl_two: x.secondary_description_lvl_two,
            display_field: displayFieldVal,
            validationMethod: x.validationmethod,
            options: GOMLabel
          } 
        } else if (x.field_description === 'Winner/Runner UP') {
          //console.log('setNominationContent  x 747', x, displayFieldVal)
          return {
            type: x.form_field_type,
            description: x.field_description,
            secondaryDescription: x.field_secondary_description,
            isRequired: x.required_nomination_field,
            checkboxLabels: x.checkbox_labels,
            errorClass: '',
            index: index + x.form_field_type,
            description_lvl_two: x.description_lvl_two,
            secondary_description_lvl_two: x.secondary_description_lvl_two,
            display_field: displayFieldVal,
            validationMethod: x.validationmethod,
            options: WinnerRunnerUpLabel
          }
        }
        else {
          //console.log('setNominationContent  x 764', x, displayFieldVal)
          return {
            type: x.form_field_type,
            description: x.field_description,
            secondaryDescription: x.field_secondary_description,
            isRequired: x.required_nomination_field,
            checkboxLabels: x.checkbox_labels,
            errorClass: '',
            index: index + x.form_field_type,
            description_lvl_two: x.description_lvl_two,
            secondary_description_lvl_two: x.secondary_description_lvl_two,
            display_field: displayFieldVal,
            validationMethod: x.validationmethod
          }
        }
      })
      console.log('setNominationContent 778', self.nominationContent)
      if (self.nominationContent.length > 1) {
        console.log('setNominationContent 780 ', self.nominationContent)
        self.nominationContent = self.nominationFields.map(function (x, i) {
          return {label: x.description, content: self.nominationContent[i].content, required: x.isRequired, validated: false, displayField: x.displayField}
        })
      } else  {
        console.log('setNominationContent 785', self.nominationFields, self.nominationContent)
        self.nominationContent = self.nominationFields.map(function (x) {
          return {label: x.description, content: '', required: x.isRequired, validated: false, displayField: x.displayField}
        })
      }
    },
    loadContent: function () {
      this.madeNomination = false
      this.nominatedPerson = ''
      document.title = this.$route.name + ' - ThinkTank'
      WordpressRestAPI.getViewContent('nomination_event?nomination_event_category=139&_embed&per_page=1')
      .then(response => {
        console.log('loadContent response.data ', response.data)
        this.award = response.data[0]
        console.log('loadContent this.award ', this.award, this.award.content.rendered)
        var self = this
        self.getHCBPBUDetails()
        .then(() => {
          console.log('Nominations fetching complete.');
          self.contentReady = true
          if (self.award.include_nomination_form[0] === 'Yes') {
            // Reinitiate every variable related with form
            self.NominationTeamNames = []
            self.isTeamAwards = true
            self.NominationButtonText = 'Add Nominee'
            self.NominationLabel = 'BU Employee of the year'
            self.NominationPlaceholder = 'Search by email address, seperate multiple email by comma...'
            console.log(' this.award.nomination_fields[0][0] ', this.award.nomination_fields[0][0])
            self.setNominationContent(this.award.nomination_fields[0][0])
            console.log(' this.award.nomination_fields[0][0] ', this.award.nomination_fields[0][0])
          }
        })
        .catch(error => {
          console.error('Error:', error);
          // Handle the error if needed
        });
      })
      .catch(e => {
        this.contentLoadError = 'Oops! We had a problem with loading this Recognition. Please try again later.'
        console.error(e)
        this.contentReady = true
      })
    },
    searchNomineeList: function (newQuery) {
      if ( newQuery.length > 2 )
      WordpressRestAPI.getCustomViewContent('getNominees/v1/nomineelist?search=' + newQuery)
      .then((res) => {
        this.nomineesList = res.data
      })
    },
    checkNominationCount: function(urlString = false, monetaryChange = false) {
      this.createNominationError = ''
      this.searchingForEmployeeError = ''
      this.submitClicked = true
      if (!urlString) {
        let emailSlug = this.nominatedPerson.replace(/\./g, '-').replace(/@/g, '').toLowerCase()
        urlString = '?slug='+emailSlug+'&type=BUEOY&BU='+this.selectedBUOption+'&GOM='+this.selectedGOMOption+'&winnerRunnerStatus='+this.selectWinnerRunnerUpStatus+'&BUOptions='+this.BUOptions
      }
      let status = true
      WordpressRestAPI.getCustomViewContent('getNomination/v1/getBUUserNominationPerCategory'+urlString)
      .then(response => {
        console.log('review list-> ', response.data)
        if (response.data !== false) {
          console.log('review list-> ', response.data.user_count , this.selectWinnerRunnerUpStatus, response.data.BU_winner_count)
          if (response.data && response.data.user_count) {
            // Loop through user_count
            this.createNominationError = ''
            response.data.user_count.forEach(user => {
              const userEmail = user[0]
              const userStatus = user[1]
              // Check if userStatus is false and alert
              if (response.data.BU_winner_count > 0 && this.selectWinnerRunnerUpStatus === 'Winner') {
                alert(`Winner already has been submitted for ${this.selectedGOMOption}`)
                status = false
                this.contentReady = true
                this.createNominationError = `Winner already has been submitted for ${this.selectedGOMOption}`
                this.creatingNomination = false
                this.submitClicked = false
              }
              else if (response.data.this_month_count[0] > 0) {
                alert(`User ${userEmail} is already nominated for BU employee award. Hence you can not nominate this user. Please remove this user`)
                status = false
                this.contentReady = true
                this.createNominationError = this.createNominationError + ` User ${userEmail} is already nominated for BU employee award. Hence you can not nominate this user. Please remove this user`
                this.creatingNomination = false
                this.submitClicked = false
              }
              console.log(' response.data.BU_runner_up_count ', response.data.BU_runner_up_count, ' response.data.max_runner_up ', response.data.max_runner_up, ' this.selectWinnerRunnerUpStatus ', this.selectWinnerRunnerUpStatus)
              if (response.data.BU_runner_up_count >= response.data.max_runner_up && this.selectWinnerRunnerUpStatus === 'Runner UP') {
                alert(`You have already nominated ${response.data.max_runner_up} Runner-Up nominations. More than ${response.data.max_runner_up} Runner-Up nominations cannot be made`)
                status = false
                this.contentReady = true
                this.createNominationError = this.createNominationError + ` You have already nominated ${response.data.max_runner_up} Runner-Up nominations. More than ${response.data.max_runner_up} Runner-Up nominations cannot be made.`
                this.creatingNomination = false
                this.submitClicked = false
              }
              if (status === false) {
                return true
              } else {
                this.setNominee()
              }
            })
          }
        } else {
          this.contentReady = true
          this.childContentLoadError = 'Oops! We had a problem with loading your nominations. Please try again later.'
        }
      })
      .catch(e => {
        this.contentReady = true
        this.childContentLoadError = 'Oops! We had a problem with loading your nominations. Please try again later.'
        console.error(e)
      })
      return false
    }
  },
created () {
  document.title = this.$route.name + ' - ThinkTank'
  var self = this
  var usernameOptions = {
    method: 'GET',
    headers: {
      'Authorization': localStorage.getItem('userToken'),
      'Content-Type': 'application/json'
    },
    json: true
  }
  WordpressRestAPI.endpointWithAuthetication(usernameOptions, 'users/me?context=edit')
    .then(function (userResponse) {
      self.userDetails = userResponse.data
      if (self.userDetails) {
        console.log(' self.userDetails ', self.userDetails)
        console.log(' self.userDetails ', self.userDetails.email)

        self.loadContent()
      }
  })
  .catch(e => {
      console.error(e)
  })
},
watch: {
  mediaUploadCallDone(val) {
    this.checIfBothCallCompleted()
  },
  sendEmaiCallDone(val) {
    this.checIfBothCallCompleted()
  },
  nominatedPerson (newQuery, oldQuery) { 
    if (newQuery != '')
      this.searchNomineeList(newQuery) 
  },
  '$route' (to, from) {
    this.contentReady = false
    this.loadContent()
  }
}
}
</script>

<style lang="less">
.featuredImg {
  img {
    width: 100%;
  }
}
.box {.icon { text-align: center; position: relative; }}
.box { .icon { .image { position: relative; z-index: 2; width: 50px; height: 50px; line-height: 50px; border-radius: 50%; background: #09ced6; vertical-align: middle; }}}
.box { .icon:hover { .image { background: #63B76C; }}}
.box { .icon { .image { i { color: #fff !important; border: 1px solid white; padding: 10px; border-radius: 50%; min-width: 38px;}}}}
.box { .icon { .info { margin-top: -45px; margin-left: 20px; padding: 15px 20px 10px 0px; }}}
.box { .icon { .infoaqua { background-color:#CEF6F8; }}}
.box { .icon { .infogrey { background-color:#F8F8F8; }}}
.box { .icon { .infowhite { background-color:#FFFFFF; }}}
.box { .icon { .info { h3 { font-weight: 500;  margin: 0 0 0 50px; text-align: left; color: #09ced6; }}}}
.box { .icon { .info { h5 { font-weight: 500;  margin: 0 0 0 50px; text-align: left; color: #09ced6; }}}}
.box { .icon { .info { ul {list-style: none; margin-left: 20px;}}}}
.box { .icon { .info { ul { li::before { content: "\2022"; color: #09ced6; display: inline-block; width: 1em; margin-left: -1em;}}}}}
.box { .icon { .info { .miniseparator {width: 55px; border-bottom: 5px solid #09ced6; margin-left: 50px;}}}}
.box { .icon { .info { p {margin-left: 40px;}}}}
.aquacolor {color:#09ced6;}
.navycolor {color: navy;}
</style>


// WEBPACK FOOTER //
// src/components/routes/VEAwardsEmployeeYear.vue